import { useAppSelector } from 'store/store';
import { ROLE_TENANT_TECHNICIAN_COORDINATOR } from 'shared/permissions/roles';

export function useIsTechnicianCoordinator(): boolean {
  const groups = useAppSelector((state) => state.auth.groups);
  return groups?.includes(ROLE_TENANT_TECHNICIAN_COORDINATOR) ?? false;
}
